import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
//import CustomOption from '../../utils/Elements/CustomOption';
import { CountContext, ParentContext, CompanyContext, ActivityContext } from '../../layouts/Dashboard/LayoutDashboard';
import { Pagination, Button, FloatingLabel, Nav } from 'react-bootstrap';
import { ContactCard } from './ContactCard';
import { ContactForm } from './ContactForm';
import { ActivityForm } from '../Activities/ActivityForm';
import { AlertElement } from '../../utils/Elements/AlertElement';
import { SearchableDropdown } from '../../utils/Elements/SearchableDropdown';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import '../Pages.css';

export const Contacts = () => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const contactsPagedEndpoint = `${api}/v1/individuals/paged`;
  const individualsSearch = `${api}/v1/individuals/search?searchterm=`;

  const navigate = useNavigate();

  // State management
  const { setContactCount } = useContext(CountContext);
  const { selectedParentID } = useContext(ParentContext);
  const { selectedCompanyID } = useContext(CompanyContext);
  const { setSearchOptions } = useContext(ActivityContext);

  const [contacts, setContacts] = useState([]);
  
  const [allCollapsed, setAllCollapsed] = useState(0);
  const [userCollapsed, setUserCollapsed] = useState(false);
  const [collapseButtonText, setCollapseButtonText] = useState('Collapse All');

  //const [identity, setIdentity] = useState({});
  const [showActivityForm, setActivityForm] = useState(false);
  const [activitySelected, setActivity] = useState({});

  const [showContactForm, setContactForm] = useState(false);
  const [contactSelected, setContactSelected] = useState({});
  const [triggerIndividualRefresh, setTriggerIndividualRefresh] = useState(0);

  //display options dropdown
  const [displayOptions] = useState([
    { value: 20, label: "20 Lines" },
    { value: 50, label: "50 Lines" },
    { value: 100, label: "100 Lines" },
    { value: 200, label: "200 Lines" }
  ]);
  const [displayOption, setDisplayOption] = useState(displayOptions[0]);

  //sort options dropdown
  const [sortOptions] = useState([
    { value: 0, order: 0, label: "Name A-Z" },
    { value: 1, order: 1, label: "Name Z-A" },
  ]);
  const [sortOption, setsortOption] = useState(sortOptions[0]);


  //individual filter
  const defaultIndividualFilter = { label: "All", value: 0 };

  //const [individuals, setIndividuals] = useState([defaultIndividualFilter]); //not used
  //const [individualsLoading, setIndividualsLoading] = useState(false); //not used

  const [individualFilter, setIndividualFilter] = useState(defaultIndividualFilter); //0=all
  const [filterTotal, setfilterTotal] = useState(0);

  //paginaiton
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalDisplayed, setTotalDisplayed] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [loading, setLoading] = useState(false); //this dims cards when they are dgin refreshed

  const [filterDescription, setFilterDescription] = useState('');
  const [noRecordsMessage, setNoRecordsMessage] = useState('');
  const [followUpActivity, setFollowUpActivity] = useState({});
  // Functions to handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };
  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  //collapse management
  const collapseAll = () => {
    if (!userCollapsed) setAllCollapsed(1);
  };
  const expandAll = () => {
    if (!userCollapsed) setAllCollapsed(0);
  };
  const handleToggleCollapse = () => {
    setUserCollapsed(true);
    setAllCollapsed(1 - allCollapsed);
  };

  // Function to handle the change in cards per page
  const handleDisplayChange = (option) => {
    setDisplayOption(option);
    setCurrentPage(1); // Reset to the first page
    option.value >= 50 ? collapseAll() : expandAll();
  };

  // Function to handle Sort change
  const handleSortChange = (option) => {
    setsortOption(option);
  };

  // Function to handle Filter Contact
  const handleIndividualFilterChange = (value) => {
    console.log("handleIndividualFilterChange", value)
    let filter = defaultIndividualFilter;
    console.log("handleIndividualFilterChange filter", value)
    if (!!value) filter = value;

    if (individualFilter.value === 0 && filter.value !== 0) {
      setfilterTotal(filterTotal + 1);
    } else if (individualFilter.value !== 0 && filter.value === 0) {
      setfilterTotal(filterTotal - 1);
    }

    setIndividualFilter(filter);
    setCurrentPage(1);
  }

  // Pagination Carousel
  const renderPaginationItems = () => {
    const maxVisibleItems = 5;
    const items = [];
    const startPage = Math.max(currentPage - Math.floor(maxVisibleItems / 2), 1);
    const endPage = Math.min(startPage + maxVisibleItems - 1, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    return items;
  };

  const viewActivities = (e, contact) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    setSearchOptions({ mode: 1, value: contact.IndividualId, data: contact.IndividualName });
    navigate('/activities');
  };

  const openActivityForm = (e, contact) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    let activity ={}
    //If follow-up then assign contact to activity
    if (contact.ID === -2) {
      activity = contact
    } else {
      activity = {
        ID: 0,
        IndividualID: contact.IndividualId,
        IndividualName: contact.IndividualName
      }
    }

    setActivity(activity);
    setActivityForm(true);
  };
  const closeActivityForm = () => {
    setActivityForm(false);
  };
  const openContactForm = (e, contact) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    setContactSelected(contact);
    setContactForm(true);
  };
  const openFeedback = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLSddmXQJBxtcMHndW_M6E5oVf82EtcCArYChWtwArf40qZx40Q/viewform";
    window.open(url, '_blank');
  };
  const closeContactForm = () => {
    setContactForm(false);
    fetchContacts(); //refresh page
  };
  const getStoredToken = () => {
    return localStorage.getItem('token');
  };

  const storedToken = getStoredToken();

  const loadIndividualOptions = async (searchterm) => {
    let results = [];
    const response = await fetch(individualsSearch + searchterm + `&parentId=${selectedParentID}&companyId=${selectedCompanyID}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }
    return results;
  };


  //load the individuals filter dropdown
  //not used
  //const fetchIndividualFilters = async () => {

  //  //if (storedToken && (selectedParentID || selectedCompanyID)) {
  //  if (storedToken) {

  //    try {
  //      setIndividualsLoading(true);
  //      const response = await fetch(individualsListEndpoint + `?parentId=${selectedParentID}&companyId=${selectedCompanyID}`, {
  //        method: 'GET',
  //        headers: {
  //          Authorization: `Bearer ${storedToken}`,
  //          'Content-Type': 'application/json',
  //        }
  //      });
  //      if (response.ok) {
  //        const data = await response.json();
  //        data.unshift(defaultIndividualFilter);
  //        setIndividuals(data);
  //        setIndividualsLoading(false);

  //      } else {
  //        setIndividuals(defaultIndividualFilter);
  //        setIndividualsLoading(false);
  //        console.error('Failed to fetch individuals');
  //      }

  //    } catch (error) {
  //      setIndividuals(defaultIndividualFilter);
  //      setIndividualsLoading(false);
  //      console.error('Failed to fetch individuals', error);
  //    }

  //  }

  //};

  //load the page contact cards
  const fetchContacts = async () => {

    if (storedToken && (selectedParentID || selectedCompanyID || individualFilter.value )) {

      setLoading(true);

      const identity = jwtDecode(storedToken);

      const payload = {
        EmployeeUID: identity.sub,
        ParentID: selectedParentID,
        CompanyID: selectedCompanyID,
        PageNo: currentPage,
        PageSize: displayOption.value,
        SortBy: sortOption.value,
        SortOrder: sortOption.order,
        FilterContact: individualFilter.value,
      };
      console.log("Payload ",payload);

      try {
        const response = await fetch(contactsPagedEndpoint, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setContacts(data.Contacts);
          setTotalRecords(data.TotalCount);
          setTotalDisplayed(Math.min(data.Contacts.length, displayOption.value));
          setTotalPages(Math.ceil(data.TotalCount / displayOption.value));
          setContactCount(data.UnfilteredCount);  //this sets the count on the upper nav bar
          setLoading(false);

        } else {
          setLoading(false);
          console.error('Failed to fetch companies');
          toast.error("Failed to load contacts", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });
        }
      } catch (error) {
        setLoading(false);
        console.error('Failed to fetch companies', error);
        toast.error("Failed to load contacts", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          paueOnHover: true,
          theme: 'colored'
        });
      }

    } else {
      console.log("fetchContacts clear data");
      setContacts([]);
      setTotalRecords(0);
      setTotalDisplayed(0);
      setTotalPages(0);
    }
  };

  const buildNoRecordsMsg = () => {
    var msg;
    if (loading) {
      msg = "Loading...please wait";
    } else if ((selectedParentID && selectedParentID !== 0) || (selectedCompanyID && selectedCompanyID !== 0)) {
      msg = "No Contacts found.";
    } else {
      msg = "Please select a Company Parent, a Company, or a Contact.";
    }
    setNoRecordsMessage(msg);
  };

  const buildFilterMsg = () => {
    //displaying first {totalDisplayed} Contacts of {totalRecords} | {filterTotal} filters applied
    //displaying next  {totalDisplayed} Contacts of {totalRecords} | {filterTotal} filters applied
    //displaying last  {totalDisplayed} Contacts of {totalRecords} | {filterTotal} filters applied
    //displaying first {totalDisplayed} Contacts of {totalRecords} found | {filterTotal} filters applied
    var msg;
    if (loading) {
      msg = "Loading...please wait";
    } else {
      msg = 'displaying '
        + (currentPage === 1 ? 'first' : currentPage === totalPages ? 'last' : 'next')
        + ' ' + totalDisplayed + ' Contacts of ' + totalRecords + (filterTotal !== 0 ? ' found ' : '') + " | " + filterTotal + ' filters applied.';
    }
    setFilterDescription(msg);
  };

  const resetFilters = () => {
    setIndividualFilter(defaultIndividualFilter);
    setfilterTotal(0);
  };

  useEffect(() => {
    setCollapseButtonText(allCollapsed ? 'Expand All' : 'Collapse All');
  }, [allCollapsed]);


  //filter message
  useEffect(() => {
    buildFilterMsg();
  }, [loading, currentPage, totalPages, totalDisplayed, totalRecords, filterTotal]);

  useEffect(() => {
    console.log(followUpActivity)
    if (followUpActivity && followUpActivity.ID === -2) {
      openActivityForm(null, followUpActivity);
    }
  }, [followUpActivity]);
  
  //no records message
  useEffect(() => {
    buildNoRecordsMsg();
  }, [selectedParentID, selectedCompanyID, individualFilter, loading]);

  //load search filters
  useEffect(() => {
    //fetchIndividualFilters(); //used in individual filter dropdown
    //this forces the async select to reload

    console.log("UE: 1");

    handleIndividualFilterChange(defaultIndividualFilter);
    setTriggerIndividualRefresh(Math.random());

    //if (selectedParentID === 0 && selectedCompanyID === 0) {
    //  handleIndividualFilterChange(defaultIndividualFilter);
    //  setTriggerIndividualRefresh(Math.random());
    //} else {
    //  handleIndividualFilterChange(defaultIndividualFilter);
    //  setTriggerIndividualRefresh(Math.random());
    //}

  }, [selectedParentID, selectedCompanyID]);

  //load contact cards
  useEffect(() => {

    console.log("UE: 2");
    console.log("UE: 2 > " + individualFilter.label);

    fetchContacts();
  }, [selectedParentID, selectedCompanyID, currentPage, individualFilter, sortOption, displayOption]);


  //handle one-time startup initializations
  // useEffect(() => {

  //  const fetchAccount = async () => {
  //    try {
  //       const response = await fetch(contactsPagedEndpoint, {
  //         method: 'POST',
  //         headers: { Authorization: `Bearer ${storedToken}`, 'Content-Type': 'application/json', },
  //       });
  //       console.log("Response ",response.ok, response.status)
  //       if (response.status === 401) {
  //         console.log("Failed to load Contacts");
  //         navigate('/');
  //       }
  //     const data = await response.json();
  //       console.log("Data: ",data)
  //    } catch (error) {
  //      console.error('Error:', error);
  //    }
  //  };

  //  if (storedToken) {
  //    fetchAccount();
  //  } else {
  //    console.log('Token not found in localStorage');
  //  }
  // }, [contactsPagedEndpoint]);


  return (
    <>
      <div className="sticky-top">

        {/*<Nav className='navbar navbar-expand-lg nav-card-actions'>*/}
        {/*  <div className='container'>*/}
        {/*    <div className='displaying-wrapper'>*/}
        {/*      <div className='navbar-text page-title'>Contacts</div>*/}
        {/*      <div className='navbar-text filter-description'>*/}
        {/*        {filterDescription}*/}
        {/*        {filterTotal !== 0 ?*/}
        {/*          <Button className="remove-filter-link" onClick={resetFilters}>remove filters</Button>*/}
        {/*          : null}*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className='d-flex'>*/}
        {/*      <button className='btn btn-outline-info btn-add-contact' onClick={openContactForm}>*/}
        {/*        <div className='hidden-sm-down'>Add Contact</div>*/}
        {/*      </button>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</Nav>*/}

        <Nav className='navbar navbar-expand-lg nav-card-actions'>
          <div className='container'>
            <div className='row nav-row page-action-row'>
              <div className='col-sm-12 col-md-6'>
                <div className='displaying-wrapper row'>
                  <div className='col-sm-12 col-md-3 page-title-wrapper'>
                    <div className='navbar-text page-title'>Contacts</div>
                  </div>
                  <div className='col-sm-12 col-md-9'>
                    <div className='navbar-text filter-description'>
                      {filterDescription}
                      {filterTotal !== 0 ?
                        <Button className="remove-filter-link" onClick={resetFilters}>remove filters</Button>
                        : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-sm-12 col-12 col-md-6 align-self-end align-prospect'>
                <div className='d-flex mobile-button-flow'>
                  <button className='btn btn-outline-info btn-add-feedback' onClick={openFeedback}>
                    <div className='hidden-sm-down'>Feedback</div>
                  </button>
                  <button className='btn btn-outline-info btn-add-contact' onClick={openContactForm}>
                    <div className='hidden-sm-down'>Add Contact</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Nav>

        <Nav className='navbar navbar-expand-lg nav-card-dropdowns justify-content-end'>
          <div className='container'>
            <div className='row filter-grid'>

              <div className='col-12 col-sm-12 col-md-6'>
                <div className='row justify-content-start'>
                  <div className='filter-item-salesrep col-auto'>

                    <SearchableDropdown
                      onSearch={loadIndividualOptions}
                      onUpdate={handleIndividualFilterChange}
                    />

                  </div>
                </div>
              </div>


              <div className='p-0-desktop col-12 col-sm-12 col-md-6'>
                <div className='row justify-content-end'>
                  <div className='filter-item-collapse col-12 col-md-auto'>
                    <div className='collapse-all-inner'>
                      <Button className='btn-collapse' variant="primary" onClick={handleToggleCollapse}>
                        {collapseButtonText}<i className={collapseButtonText === 'Collapse All' ? "i-collapse fa fa-compress" : "i-collapse fa fa-expand"} aria-hidden="true" />
                      </Button>
                    </div>
                  </div>


                  <div className='p-0-desktop filter-item-display col-12 col-md-auto'>
                    <FloatingLabel controlId="floatingSelect" className="floating-select" label={`Display/Page:`}>
                      <Select
                        className="filter-contact-display"
                        classNamePrefix="select"
                        options={displayOptions}
                        value={displayOption}
                        onChange={handleDisplayChange}
                      />
                    </FloatingLabel>
                  </div>

                  <div className='p-0-desktop filter-item-alpha col-12 col-md-auto'>
                    <FloatingLabel controlId="floatingSelect" className="floating-select" label={`Sort by:`}>
                      <Select
                        className="filter-contact-sort"
                        classNamePrefix="select"
                        options={sortOptions}
                        value={sortOption}
                        onChange={handleSortChange}
                      />
                    </FloatingLabel>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </Nav>

        {/*<Nav className='navbar navbar-expand-lg nav-card-dropdowns justify-content-end'>*/}
        {/*  <div className='container'>*/}
        {/*    <div className='row filter-grid-container'>*/}
        {/*      <div className='col-12 col-sm-12 col-md-6 filter-grid-left'>*/}
        {/*        <div className='row filter-row'>*/}
        {/*          <FloatingLabel controlId="filterIndividual" className="floating-select" label={`Contact`}>*/}
        {/*            <AsyncSelect*/}
        {/*              name="filterIndividual"*/}
        {/*              className="filter-contact-individuals"*/}
        {/*              classNamePrefix="select"*/}
        {/*              isClearable={true}*/}
        {/*              key={triggerIndividualRefresh} //this is the magic bit that forces the reload when the parent or company changes*/}
        {/*              cacheOptions*/}
        {/*              loadOptions={loadIndividualOptions}*/}
        {/*              defaultOptions={true}*/}
        {/*              value={individualFilter}*/}
        {/*              onChange={handleIndividualFilterChange}*/}
        {/*              menuPosition={'fixed'} //this to allows option menu to open on top when there is not room to open on bottom*/}
        {/*              menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal*/}
        {/*              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}*/}
        {/*            />*/}

        {/*            */}{/*<Select*/}
        {/*            */}{/*  name="filterIndividual"*/}
        {/*            */}{/*  className="filter-contact-individuals"*/}
        {/*            */}{/*  classNamePrefix="select"*/}
        {/*            */}{/*  isDisabled={selectedParentID === 0 && selectedCompanyID === 0}*/}
        {/*            */}{/*  isLoading={individualsLoading}*/}
        {/*            */}{/*  isClearable={true}*/}
        {/*            */}{/*  isSearchable={true}*/}
        {/*            */}{/*  options={individuals}*/}
        {/*            */}{/*  value={individualFilter}*/}
        {/*            */}{/*  onChange={handleIndividualFilterChange}*/}
        {/*            */}{/*  filterOption={createFilter({ ignoreAccents: false })} //this for performance*/}
        {/*            */}{/*  components={{ Option: CustomOption }} //this for performance*/}
        {/*            */}{/*/>*/}

        {/*          </FloatingLabel>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className='col-12 col-sm-12 col-md-6 filter-grid'>*/}
        {/*        <div className='row filter-row'>*/}
        {/*          <div className='filter-item-collapse col-12 col-md-auto'>*/}
        {/*            <Button className='btn-collapse' variant="primary" onClick={handleToggleCollapse}>*/}
        {/*              {collapseButtonText}<i className={collapseButtonText === 'Collapse All' ? "i-collapse fa fa-compress" : "i-collapse fa fa-expand"} aria-hidden="true" />*/}
        {/*            </Button>*/}
        {/*          </div>*/}
        {/*          <div className='filter-item-display col-12 col-md-auto'>*/}
        {/*            <FloatingLabel className="floating-select" label={`Display/Page:`}>*/}
        {/*              <Select*/}
        {/*                className="filter-contact-display"*/}
        {/*                classNamePrefix="select"*/}
        {/*                options={displayOptions}*/}
        {/*                value={displayOption}*/}
        {/*                onChange={handleDisplayChange}*/}
        {/*              />*/}
        {/*            </FloatingLabel>*/}
        {/*          </div>*/}
        {/*          <div className='filter-item-sort col-12 col-md-auto'>*/}
        {/*            <FloatingLabel className="floating-select" label={`Sort by:`}>*/}
        {/*              <Select*/}
        {/*                className="filter-contact-sort"*/}
        {/*                classNamePrefix="select"*/}
        {/*                options={sortOptions}*/}
        {/*                value={sortOption}*/}
        {/*                onChange={handleSortChange}*/}
        {/*              />*/}
        {/*            </FloatingLabel>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</Nav>*/}



        {contacts && totalRecords > displayOption.value ? (
          <div className='navbar navbar-expand-lg nav-card-pagination'>
            <div className='pagination-wrapper'>
              <Pagination>
                <Pagination.First onClick={handleFirstPage}>
                  <i className="fa fa-angle-double-left pagination-icon-left" aria-hidden="true" />
                  First
                </Pagination.First>
                <Pagination.Prev onClick={handlePrevPage}>
                  <i className="fa fa-angle-left pagination-icon-left" aria-hidden="true" />
                  Previous
                </Pagination.Prev>
                {renderPaginationItems()}
                <Pagination.Next onClick={handleNextPage}>
                  Next
                  <i className="fa fa-angle-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Next>
                <Pagination.Last onClick={handleLastPage}>
                  Last
                  <i className="fa fa-angle-double-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Last>
              </Pagination>
            </div>
          </div>
        ) : (
          <div className="pagination-grid-empty"></div>
        )}

      </div>
      <ActivityForm showModal={showActivityForm} closeModal={closeActivityForm} activityInfo={activitySelected} setFollowUp={setFollowUpActivity}></ActivityForm>
      <ContactForm showModal={showContactForm} closeModal={closeContactForm} contactInfo={contactSelected}></ContactForm>
      {contacts && contacts.length > 0 ?
        (
          <div className='container'>
            <div className={loading ? 'cards-loading' : 'cards-loaded'}>
              {contacts.map((contact, index) => (
                <ContactCard
                  key={index}
                  contact={contact}
                  eventKey={String(allCollapsed)}
                  loading={loading}
                  editContact={(e, value) => openContactForm(e, value)}
                  addActivity={(e, value) => openActivityForm(e, value)}
                  viewActivity={(e, value) => viewActivities(e, value)}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className='container'>
            <AlertElement textBody={noRecordsMessage} />
          </div>
        )}
    </>
  )
};